import Action from 'cadenza/action';

export default class ConditionAction extends Action {

  constructor (selectorId, conditionName, mapElement, options) {
    super(options);
    this._selectorId = selectorId;
    this._conditionName = conditionName;
    this._mapElement = mapElement;
  }

}
